import { configureStore } from "@reduxjs/toolkit";
import { combineReducers, Store } from "redux";
import authReducer from "store/reducers/AuthSlice";
import filterReducer from "store/reducers/FilterSlice";
import settingsReducer from "store/reducers/SettingsSlice";
import logsReducer from "store/reducers/LogsSlice";
import userReducer from "store/reducers/userSlice";
import groupsReducer from "store/reducers/GroupsSlice";
import quotesPageReducer from "store/reducers/QuotesPageReducer";
import tabsReducer from "store/reducers/TabsSlice";
import robotsReducer from "store/reducers/RobotsSlice";
import notoficationsSlice from "store/reducers/NotificationSlice";
import quotes from "./reducers/quotes";
import modals from "./reducers/modal";

const rootReducer = combineReducers({
    auth: authReducer,
    tabs: tabsReducer,
    users: userReducer,
    filter: filterReducer,
    settings: settingsReducer,
    logs: logsReducer,
    groups: groupsReducer,
    quotesPage: quotesPageReducer,
    notifications: notoficationsSlice,
    quotes: quotes,
    robots: robotsReducer,
    modals,
});

const store: Store = configureStore({
    reducer: rootReducer,
    // middleware: (getDefaultMiddleware) => getDefaultMiddleware({serializableCheck: false})
});
// const store = configureStore({
//     reducer: rootReducer,
// });

export type RootState = ReturnType<typeof rootReducer>;
export type RootGetState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export { store };
